import { mapGetters } from 'vuex'
import moment from 'moment'
import { rtdb } from '@/plugins/firebase'

export default {
  computed: {
    ...mapGetters(['_badgeTotals', '_user', '_userInfo'])
  },
  methods: {
    _seenLast (id) {
      let lastSeen = ((this._userInfo.seen || {})[id] || {}).last
      return lastSeen ? moment(lastSeen) : moment('1900-01-01')
    },
    _seenUpdate (id, last) {
      let badgeTotal = this._badgeTotals[id]
      if (badgeTotal) rtdb.ref(`users/console/${this._user.uid}/seen/${id}/total`).set(badgeTotal)
      if (last) rtdb.ref(`users/console/${this._user.uid}/seen/${id}/last`).set(moment(last).format())
    },
    _seenWatch (id, condition) {
      this._seenUpdateId = id
      if (condition) this._seenUpdateCondition = condition
    }
  }
}
